module.exports = __webpack_public_path__ + "img/iconProvince3.64a5f363.svg";